import React, { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  ImageListItem,
  ImageListItemBar,
  Menu,
  MenuItem,
  Modal,
  Typography
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import StarIcon from "@mui/icons-material/Star";
import SkipPreviousIcon from "@mui/icons-material/SkipPrevious";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import {
  DELETE_PROJECTS_FAVOURITE_IMAGES,
  GET_POST_COMMENTS,
  POSTS_USER_SETTINGS,
  SAVE_PROJECTS_FAVOURITE_IMAGES
} from "../../constant/Apipath";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import { Getrequestcall } from "../../request/Getrequest";
import { BIRed } from "../../assets/helpers";
import { English } from "../../constant/EnglishFallback";
import PostComment  from "../new-community/PostComment";

const iconButtonOverlayStyle = {
  position: "absolute",
  zIndex: 99,
  backgroundColor: "rgba(0, 0, 0, 0.4)", // dark & transparent
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.6)" // darker on hover
  },
  color: "darkgrey"
};

const ProjectPhotosModal = ({
  open,
  onClose,
  selectedIndex,
  photos,
  getUpdatedPhotos,
  projectDetails
}) => {
  let { id } = useParams();
  const { loginData, multiLanguageData, selectedLanguage } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;

  const [photoList, setPhotoList] = useState([...photos]);
  const [posts, setPosts] = useState(photos || []);
  const [selectedImage, setSelectedImage] = useState(photoList?.[selectedIndex ?? 0]);
  const [selectedImageIndex, setSelectedImageIndex] = useState(selectedIndex ?? 0);
  const [submitLoading, setSubmitLoading] = useState(false);

  const [pageNr, setPageNr] = useState(1);
  const [showComments, setShowComments] = useState(false);
  const [commentList, setCommentList] = useState([]);
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);

  const {
    TEXT_SELECT_VALID_IMAGE = English?.ProjectPhotosModal?.TEXT_SELECT_VALID_IMAGE,
    TEXT_PHOTO_TAKEN = English?.ProjectPhotosModal?.TEXT_PHOTO_TAKEN,
    TEXT_LABEL_COMMENTS = English?.ProjectPhotosModal?.TEXT_LABEL_COMMENTS,
    TEXT_COMMENT = English?.ProjectPhotosModal?.TEXT_COMMENT,
    BUTTON_REPORT = English?.ProjectPhotosModal?.BUTTON_REPORT
  } = multiLanguageData?.ProjectPhotosModal || {};

  const getPostComment = async () => {
    let res = await Getrequestcall(
      `${GET_POST_COMMENTS}/${currentUserId}/${selectedImage?.id}/${pageNr}/20/${selectedImage?.appId}/${selectedLanguage}`,
      loginData?.accessToken
    );
    let resData = res?.data?.data ?? [];
    setCommentList(resData?.reverse());
  };

  const handlePreviousPhotoClick = () => {
    let index = selectedImageIndex - 1;
    setSelectedImageIndex(index);
    setSelectedImage(photoList?.[index]);
    setShowComments(false);
  };

  const handleNextPhotoClick = () => {
    let index = selectedImageIndex + 1;
    setSelectedImageIndex(index);
    setSelectedImage(photoList?.[index]);
    setShowComments(false);
  };

  const onStarClick = async (selectedImage, isFavorite) => {
    try {
      setSubmitLoading(true);
      let obj = {};
      let apiUrl = "";
      if (isFavorite) {
        obj = {
          UserId: Number(currentUserId),
          ReturnRecordId: false,
          ReturnRecordError: true,
          DeleteList: [
            {
              projectPictureId: selectedImage?.pictureId,
              ModifiedBy: Number(currentUserId)
            }
          ]
        };
        apiUrl = DELETE_PROJECTS_FAVOURITE_IMAGES;
      } else {
        obj = {
          UserId: Number(currentUserId),
          ReturnRecordId: true,
          ReturnRecordError: true,
          SaveList: [
            {
              Id: 0,
              ProjectId: id,
              projectPictureId: selectedImage?.pictureId,
              ModifiedBy: Number(currentUserId)
            }
          ]
        };
        apiUrl = SAVE_PROJECTS_FAVOURITE_IMAGES;
      }
      await Postrequestcall(apiUrl, obj, loginData?.accessToken);
      let updatedPhotosList = [
        ...photoList.map((item) => {
          if (item?.id === selectedImage?.id && item?.pictureId === selectedImage?.pictureId) {
            return { ...item, isFavorite: !item?.isFavorite };
          } else {
            return item;
          }
        })
      ];
      setPhotoList(updatedPhotosList);
      setSelectedImage(updatedPhotosList?.[selectedImageIndex]);
      setSubmitLoading(false);
      await getUpdatedPhotos();
    } catch (error) {
      setSubmitLoading(false);
      console.log("onStarClick-> Error Updating Project Favorite Image: ", error);
    }
  };

  const handleMutePost = async (id, isMute) => {
    try {
      const mutePostObj = {
        UserId: currentUserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            PostId: Number(id),
            UserId: currentUserId,
            IsHidden: false,
            IsMute: !isMute
          }
        ]
      };
      let mutePostRes = await Postrequestcall(
        POSTS_USER_SETTINGS,
        mutePostObj,
        loginData?.accessToken
      );
      if (mutePostRes?.data?.message === "OK") {
        const updatedPosts = posts.map((post) => {
          if (post?.id === id) {
            return {
              ...post,
              isMute: !post.isMute // Toggle the isMute key
            };
          }
          return post; // Keep the other posts unchanged
        });
        setPosts(updatedPosts);
      }
    } catch (err) {
      console.log("handleMutePost-> Error Updating User Setting: ", err);
    }
  };

  const onCommentClick = (showComments) => {
    setShowComments((preValue) => !preValue);
    if (!showComments) {
      getPostComment();
    }
  };

  function getPictureUrl(item) {
    if (item == null) {
      return null;
    } else if (item == "") {
      return null;
    } else {
      return item;
    }
  }

  const handleCommentPost = async () => {
    let updatedPhotosList = [
      ...photoList.map((item) => {
        if (item?.id === selectedImage?.id && item?.pictureId === selectedImage?.pictureId) {
          return { ...item, nrComments: item?.nrComments + 1 };
        } else {
          return item;
        }
      })
    ];
    setPhotoList(updatedPhotosList);
    setSelectedImage(updatedPhotosList?.[selectedImageIndex]);
  };

  return (
    <>
      {showComments && (
        <PostComment
          posts={posts}
          setPosts={setPosts}
          pageName={"Project Post"}
          handleMutePost={handleMutePost}
          handleCommentPost={handleCommentPost}
          postItem={{
            id: selectedImage?.id,
            formatTypeId: selectedImage?.formatTypeId,
            appId: selectedImage?.appId,
            pictureList: [selectedImage]
          }}
          open={showComments}
          onClose={() => setShowComments(false)}
          from={"Project Photos"}
        />
      )}

      <Modal open={open}>
        <Box className="user-modal-responsive">
          <ImageListItem key={selectedImage?.pictureUrl} sx={{ pt: 1 }}>
            <IconButton
              onClick={async () => {
                onClose();
                await getUpdatedPhotos();
              }}
              size="small"
              sx={{
                ...iconButtonOverlayStyle,
                top: "4%",
                left: "2%"
              }}>
              <CloseIcon />
            </IconButton>
            <IconButton
              loading={submitLoading}
              onClick={() => onStarClick(selectedImage, selectedImage?.isFavorite)}
              size="small"
              sx={{
                ...iconButtonOverlayStyle,
                top: "4%",
                right: "2%"
              }}>
              <StarIcon sx={{ color: selectedImage?.isFavorite ? "gold" : "darkgray" }} />
            </IconButton>

            {selectedImageIndex !== 0 && (
              <IconButton
                onClick={handlePreviousPhotoClick}
                size="small"
                sx={{
                  ...iconButtonOverlayStyle,
                  top: "40%",
                  left: "2%"
                }}>
                <SkipPreviousIcon />
              </IconButton>
            )}

            {selectedImageIndex !== photos?.length - 1 && (
              <IconButton
                onClick={handleNextPhotoClick}
                size="small"
                sx={{
                  ...iconButtonOverlayStyle,
                  top: "40%",
                  right: "2%"
                }}>
                <SkipNextIcon />
              </IconButton>
            )}

            <img
              style={{ height: "400px", position: "relative" }}
              src={`${selectedImage?.pictureUrl}`}
              alt={"picture"}
              loading="lazy"
            />
            <ImageListItemBar
              position="below"
              title={
                <Typography variant="body1">
                  {`${selectedImage.postedByFirstName} ${selectedImage.postedByLastName} (${selectedImage.tradeName})`}
                </Typography>
              }
              subtitle={
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between"
                  }}>
                  <Typography variant="body2">
                    {`${TEXT_PHOTO_TAKEN} : `}
                    {selectedImage.pictureDateTime != null ? selectedImage.pictureDateTime : "N/A"}
                  </Typography>

                  <Box
                    sx={{ flexDirection: "row",  alignItems: "center",  display: "flex" }}
                    
                    
                    style={{ cursor: "pointer" }}
                    onClick={() => onCommentClick(showComments)}>
                    <Typography sx={{ pr: 0.5 }}>
                      {selectedImage?.nrComments || 0} {TEXT_COMMENT}
                    </Typography>
                  </Box>
                </Box>
              }
            />
          </ImageListItem>
        </Box>
      </Modal>

      {moreMenuAnchorEl && (
        <Menu
          anchorEl={moreMenuAnchorEl}
          open={Boolean(moreMenuAnchorEl)}
          onClose={() => setMoreMenuAnchorEl(null)}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}>
          <MenuItem style={{ color: BIRed }} dense>
            {BUTTON_REPORT}
          </MenuItem>
        </Menu>
      )}
    </>
  );
};

export default ProjectPhotosModal;
